import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../../admin/Constant"; // Ensure this path is correct for your project

export const ReferencePackageApi = createApi({
  reducerPath: "ReferencePackageApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    addReferencePackage: builder.mutation({
      query: (data) => ({
        url: "/referencePackages/create",
        method: "POST",
        body: data,
      }),
    }),

    // Get all reference packages
    allReferencePackages: builder.query({
      query: () => ({
        url: "/referencePackages/all",
        method: "GET",
      }),
    }),

    referencePackageDetail: builder.query({
      query: (destinationId) => ({
        url: `reference-packages/${destinationId}`, // Not In Use
        method: "GET",
      }),
    }),

    referencePackageBySlug: builder.query({
      query: (slug) => ({
        url: `/referencePackages/view/${slug}`,
        method: "GET",
      }),
    }),

    relatedpackageDataBySlug: builder.query({  // Not In use
      query: (slug) => ({
        url: `/referencePackages/related-package/${slug}`,
        method: "GET",
      }),
    }),

    updateReferencePackage: builder.mutation({
      query: ({ data, slug }) => ({
        url: `/referencePackages/update/${slug}`,
        method: "PUT",
        body: data,
      }),
    }),

    deleteReferencePackage: builder.mutation({
      query: (id) => ({
        url: `/referencePackages/delete/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddReferencePackageMutation,
  useAllReferencePackagesQuery,
  useReferencePackageDetailQuery,
  useReferencePackageBySlugQuery,  // is only visible but not in use but not can be use later so dont remove it
  useRelatedpackageDataBySlugQuery,
  useDeleteReferencePackageMutation,
  useUpdateReferencePackageMutation,
} = ReferencePackageApi;
